import InnerScreenHeader from "@/components/layout/inner-screen-header"

import { useDynamicContext } from "@dynamic-labs/sdk-react-core"
import Loader from "@/components/layout/loader"
import WebhookForm from "./webhook.form"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

const queryClient = new QueryClient()

export default function WebhookScreen() {
  const { user } = useDynamicContext()

  if (!user) {
    return <Loader message="Loading user..." />
  }

  return (
    <QueryClientProvider client={queryClient}>
      <div className="flex flex-col gap-4">
        <InnerScreenHeader title="Settings" to="/settings" />
        <WebhookForm />
      </div>
    </QueryClientProvider>
  )
}
